import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { DeleteScheduledShowDocument } from './delete.generated';

export const useDeleteScheduledShow = (
  options: ApiOptions<typeof DeleteScheduledShowDocument> = {},
) => {
  const { t } = useTranslation();

  return useMutation(DeleteScheduledShowDocument, {
    ...useNotifications(DeleteScheduledShowDocument, {
      failure: t('api.common.error_generic'),
      success: (data) => {
        const count = data.deleteScheduledShow?.deletedIds.length ?? 0;
        return t('api.scheduled_show.delete_success_plural', { count });
      },
    }),

    update(cache, { data }) {
      if (!data?.deleteScheduledShow?.deletedIds.length) return;
      data.deleteScheduledShow.deletedIds.forEach((id) =>
        cache.evict({ id: `ScheduledShow:${id}` }),
      );
    },

    ...options,
  });
};
